import { Injectable } from '@angular/core';

import { APP_CONFIG } from '../../app.config';
import { RequestService } from '../../shared/services/request.service';
import { DeliveryFee } from './models/delivery-fee.model';

@Injectable()
export class DeliveryService {

	constructor(
		private requestService: RequestService
	) { }

	getDeliveryFees(storeId?: number, placeId?: number): Promise<Array<DeliveryFee>> {
		return new Promise((resolve, reject) => {
			const urlRequest: string = APP_CONFIG.WEBSERVICE.DELIVERY_FEE + (storeId ? "?storeId=" + storeId : "?placeId=" + placeId);
			this.requestService.getData(urlRequest).then((response: any) => {
				console.log(response);
				resolve(response || []);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	save(deliveryFee: DeliveryFee): Promise<any> {
		return new Promise((resolve, reject) => {
			this.requestService.postData(APP_CONFIG.WEBSERVICE.DELIVERY_FEE, deliveryFee).then((response: any) => {
				resolve(response);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	deleteDeliveryFees(id: number): Promise<void> {
		return new Promise((resolve, reject) => {
			this.requestService.deleteData(APP_CONFIG.WEBSERVICE.DELIVERY_FEE + "/" + id).then((response: any) => {
				console.log(response);
				resolve();
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/pages/store/delivery.service.ts